// extracted by mini-css-extract-plugin
export default {"main":"categories_main__sTB5i","sCategory":"categories_sCategory__p0jWT","title":"categories_title__dyGsU","show":"categories_show__6xGUc","hide":"categories_hide__CGsOI"};